import React, { useState, useRef, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import { endPoints } from "../../../constant/Environment";
import Loader from "../../../components/Loader";
import { addData, getAllData } from "../../../Utility/API";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { Button, Tab } from "react-bootstrap";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import Toaster from "../../../components/Toast";
import moment from "moment-timezone";

const UserPackageTransaction = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userTransactionList, setUserTransactionList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedPackageId, setSelectedPackage] = useState("");

  const [packageList, setPackagelist] = useState([]);
  // const [singlePackage, setSinglePackage] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSelectedPackage(value);
  };

  const getCoinPackageList = async (list) => {
    let url = `${endPoints.api.GET_PACKAGE}`;

    await getAllData(url)
      .then((response) => {
        if (response.status == "success" && response?.data?.length > 0) {
          const filteredPackageData = response?.data?.filter(
            (item) => item.isactive === 1
          );
          setPackagelist(filteredPackageData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleOk = async () => {
    setIsLoading(true);
    let url = `${endPoints.api.ADD_COIN_PACKAGE}`;
    let payload = { package_id: selectedPackageId, user_id: userId };
    const response = await addData(url, payload);
    setIsLoading(false);

    if (response.data.status === "success") {
      SuccesToast(response?.data?.message);
      setOpen(false);
      fetchPackageTransData();
    } else {
      ErrorToast(response?.data?.message);
    }
  };

  const fetchPackageTransData = () => {
    let url = `${endPoints.api.PACKAGE_USER_TRANS}/${userId}`;
    setIsLoading(true);
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        setIsLoading(false);
        if (status === "success") {
          setUserTransactionList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchPackageTransData();
    getCoinPackageList();
  }, []);

  return (
    <>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div className="col-md-12">
        <div className="custom-table-data mt-4">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <h4 className="dark-gray f-bold">Package List </h4>
            <Button
              onClick={() => {
                setOpen(true);
                setSelectedPackage("");
              }}
              variant="primary"
            >
              Add Package
            </Button>
          </div>

          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Date </TableCell>
                  <TableCell align="center">User Id </TableCell>
                  <TableCell align="center">Merchant Ref Num </TableCell>
                  <TableCell align="center">Amount </TableCell>
                  <TableCell align="center"> Package Name </TableCell>
                  <TableCell align="center"> Gold Coins </TableCell>
                  <TableCell align="center"> Saga Coins </TableCell>
                  <TableCell align="center"> 1x</TableCell>
                  <TableCell align="center"> 2x</TableCell>
                  <TableCell align="center"> 3x</TableCell>
                  <TableCell align="center"> 4x</TableCell>
                  <TableCell align="center"> 5x</TableCell>
                  <TableCell align="center"> Multiplier </TableCell>
                  <TableCell align="center"> Sc Remaining </TableCell>
                  <TableCell align="center">Free Spin</TableCell>
                  <TableCell align="center">Spin Count</TableCell>
                  <TableCell align="center"> Status </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userTransactionList?.length > 0 &&
                  userTransactionList.map((row, index) => (
                    <TableRow
                      key={row.id ?? index}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell align="center">
                        {moment(row.addeddate).format(
                          "MMMM Do YYYY, h:mm:ss a"
                        )}
                        {/* {moment(row.addeddate).format("MM/DD/YYYY")} */}
                      </TableCell>
                      <TableCell align="center">{row.id_user}</TableCell>
                      <TableCell align="center">{row.merchantRefNum}</TableCell>

                      <TableCell align="center">${row.amount}</TableCell>
                      <TableCell align="center">{row.packagename}</TableCell>

                      <TableCell align="center">{row?.goldcoins}</TableCell>
                      <TableCell align="center">{row?.sagacoins}</TableCell>
                      <TableCell align="center">{row?.sc1x}</TableCell>
                      <TableCell align="center">{row?.sc2x}</TableCell>
                      <TableCell align="center">{row?.sc3x}</TableCell>
                      <TableCell align="center">{row?.sc4x}</TableCell>
                      <TableCell align="center">{row?.sc5x}</TableCell>
                      <TableCell align="center">{row?.multplier}{"x"}</TableCell>
                      <TableCell align="center">{row?.scRemain}</TableCell>
                      <TableCell align="center">{row?.freeSpin ? "Yes" : "No"}</TableCell>
                      <TableCell align="center">{row?.spinCount}</TableCell>
                      <TableCell align="center">{row?.status}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <Dialog
          sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 600 } }}
          maxWidth="sm"
          open={open}
        >
          <DialogTitle>Coin Package List</DialogTitle>
          <DialogContent dividers>
            <InputLabel id="state-label">Coin Package</InputLabel>
            <FormControl fullWidth margin="normal">
              <Select
                labelId="state-label"
                name="package"
                value={selectedPackageId}
                onChange={handleChange}
              >
                {packageList.map((state) => (
                  <MenuItem key={state.id} value={state.id}>
                    ${state.purchase_price}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => {
                setOpen(false);
              }}
              variant="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={handleOk}
              variant="primary"
              disabled={selectedPackageId == "" ? true : false}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default UserPackageTransaction;
